// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestContainer {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }
    private _container1?: vf.gui.Container;
    private _container2?: vf.gui.Container;
    private _container3?: vf.gui.Container;
    private _container4?: vf.gui.Container;
    private _container5?: vf.gui.Container;
    private _container6?: vf.gui.Container;
    private _containerTop?: vf.gui.Container;
    private _containerLeft?: vf.gui.Container;
    private _containerRight?: vf.gui.Container;
    private _containerBottom?: vf.gui.Container;
    private _buttonList: vf.gui.Label[] = [];


    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        /** 单背景色 */
        const container1 = this._container1 = new vf.gui.Container();
        container1.style.display = "none";
        container1.name = "1";
        container1.x = 100;
        container1.y = 100;
        container1.width = 100;
        container1.height = 100;
        container1.style.left = 500;//display = "none"; 时，布局属性会失效
        container1.style.backgroundColor = 100;
        uiStage.addChild(container1);

        /** 不重复的背景 no-repeat */
        const container2 = this._container2 = new vf.gui.Container();
        container2.name = "2";
        container2.style.left = 240;
        container2.style.top = 100;
        container2.style.width = 100;
        container2.style.height = 100;
        container2.style.backgroundRepeat = "no-repeat";
        container2.style.backgroundImage = "assets/btnbg.png";
        container2.style.backgroundPositionX = 20;
        container2.style.backgroundPositionY = 50;
        container2.style.backgroundSize = [50, 50];
        uiStage.addChild(container2);

        /** 重复的背景 */
        const container3 = this._container3 = new vf.gui.Container();
        container3.name = "3";
        container3.style.left = 380;
        container3.style.top = 100;
        container3.style.width = 100;
        container3.style.height = 100;
        container3.style.backgroundRepeat = "repeat";
        container3.style.backgroundColor = 0xffffff;
        container3.style.backgroundImage = "assets/pc.png";
        container3.style.backgroundPositionX = 20;
        container3.style.backgroundPositionY = 0;
        uiStage.addChild(container3);

        /** 百分比设置元素位置与宽高 */
        const container4 = this._container4 = new vf.gui.Container();
        container4.name = "4";
        container4.style.left = 100 / (uiStage.width / 100) + "%";
        container4.style.top = 250 / (uiStage.height / 100) + "%";
        container4.style.width = 100 / (uiStage.width / 100) + "%";
        container4.style.height = 100 / (uiStage.height / 100) + "%";
        container4.style.backgroundColor = 0xffffcc;
        uiStage.addChild(container4);


        /** 百分比设置最大高度与宽度*/
        const container5 = this._container5 = new vf.gui.Container();
        container5.name = "5";
        container5.style.left = 240;
        container5.style.top = 250;
        container5.style.width = 1006;
        container5.style.height = 1006;
        container5.style.maxWidth = 100;
        container5.style.maxHeight = 100;
        container5.style.backgroundColor = 0xffffff;
        uiStage.addChild(container5);

        /** 百分比设置最小高度与宽度,设置抽点 */
        const container6 = this._container6 = new vf.gui.Container();
        container6.name = "6";
        container6.style.left = 430;
        container6.style.top = 300;
        container6.style.width = 10;
        container6.style.height = 10;
        container6.style.minWidth = 100;
        container6.style.minHeight = 100;
        container6.style.backgroundColor = 0xffffff;
        container6.style.pivotX = container6.style.pivotY = 50;
        //container6.style.scaleX = container6.style.scaleY = 1.2;
        uiStage.addChild(container6);

        /** 顶部  白色 */
        const containerTop = this._containerTop = new vf.gui.Container();
        containerTop.name = "top";
        containerTop.style.alpha = 0.7;
        containerTop.style.top = 0;
        containerTop.style.left = 0;
        containerTop.style.right = 0;
        containerTop.style.height = 50;
        containerTop.style.backgroundColor = 0xffffff;
        uiStage.addChild(containerTop);

        /** 左边  红色 */
        const containerLeft = this._containerLeft = new vf.gui.Container();
        containerLeft.name = "left";
        containerLeft.style.alpha = 0.7;
        containerLeft.style.left = 0;
        containerLeft.style.top = 0;
        containerLeft.style.bottom = 0;
        containerLeft.style.width = 50;
        containerLeft.style.backgroundColor = 0xf44336;
        uiStage.addChild(containerLeft);

        /** 右边  蓝色 */
        const containerRight = this._containerRight = new vf.gui.Container();
        containerRight.name = "right";
        containerRight.style.alpha = 0.7;
        containerRight.style.top = 0;
        containerRight.style.right = 0;
        containerRight.style.bottom = 0;
        containerRight.style.width = 50;
        containerRight.style.backgroundColor = 100;
        uiStage.addChild(containerRight);

        /** 底部  绿色 */
        const containerBottom = this._containerBottom = new vf.gui.Container();
        containerBottom.name = "bottom";
        containerBottom.style.alpha = 0.7;
        containerBottom.style.left = 0;
        containerBottom.style.right = 0;
        containerBottom.style.bottom = 0;
        containerBottom.style.height = 50;
        containerBottom.style.backgroundColor = 0x4caf50;
        uiStage.addChild(containerBottom);

        const labelContainer = new vf.gui.Container();
        containerBottom.addChild(labelContainer);

        const label = new vf.gui.Label();
        label.text = 'test';
        labelContainer.addChild(label);

        vf.gui.TickerShared.add(() => {
            container6.rotation += 1;
            //container6.style.rotation += .1;
            //console.log(container6.rotation);
        }, this);

        setTimeout(() => {
            container2.style.width = 200;
        }, 5000);




        this.getButton('设置/取消backgroundRepeat', () => {

            if (container2.style.backgroundRepeat !== "repeat") {

                container2.style.backgroundRepeat = "repeat";
            } else {
                container2.style.backgroundRepeat = "no-repeat";
            }

        }, uiStage, 650, 0);



        this.getButton('设置/取消backgroundImage', () => {

            if (container2.style.backgroundImage) {

                container2.style.backgroundImage = "";
            } else {
                container2.style.backgroundImage = "assets/btnbg.png";
            }
        }, uiStage, 650, 0);




        this.getButton('设置/取消backgroundColor', () => {

            if (container3.style.backgroundColor !== 0xffffcc) {

                container3.style.backgroundColor = 0xffffcc;
                // container3.style.backgroundImage = "assets/pc.png";
            } else {
                // container3.style.backgroundColor = 0xffffff;
                container3.style.backgroundRepeat = "repeat";
                container3.style.backgroundImage = "assets/pc.png";
            }
        }, uiStage, 650, 0);


        this.getButton('设置过渡色/取消backgroundColor', () => {

            if (container3.style.backgroundColor === undefined) {

                container3.style.backgroundColor = [[0, 171, 235, 1], [255, 255, 255, 1], [38, 192, 0, 1], [255, 0, 0, 0.5]] as any;
                // container3.style.backgroundImage = "assets/pc.png";
            } else {
                // container3.style.backgroundColor = [[0, 171, 235, 1], [255, 255, 255, 1], [38, 192, 0, 1], [255, 0, 0, 0.5]] as any;
                // container3.style.backgroundColor = 0xffffff;
                container3.style.backgroundColor = undefined;// container3.style.backgroundColor 
            }
        }, uiStage, 650, 0);

        



        this.getButton('设置/取消backgroundPositionX', () => {

            if (container2.style.backgroundPositionX !== 40) {

                container2.style.backgroundPositionX = 40;
            } else {
                container2.style.backgroundPositionX = 20;
            }
        }, uiStage, 650, 0);

        container2.style.backgroundPositionY = 50;


        this.getButton('设置/取消backgroundPositionY', () => {

            if (container2.style.backgroundPositionY !== 25) {

                container2.style.backgroundPositionY = 25;
            } else {
                container2.style.backgroundPositionY = 50;
            }
        }, uiStage, 650, 0);

        container2.style.backgroundSize = [50, 50];


        this.getButton('设置/取消backgroundSize', () => {
            const styleSize = container2.style.backgroundSize;
            if (styleSize && (styleSize[0] !== 25 || styleSize[1] !== 25)) {

                container2.style.backgroundSize = [25, 25];
            } else {
                container2.style.backgroundSize = [50, 50];
            }
        }, uiStage, 650, 0);

        this.getButton('设置/取消backgroundAlpha', () => {
            const alpha = container2.style.backgroundAlpha;
            if (alpha === 1) {

                container2.style.backgroundAlpha = 0.5;
            } else {
                container2.style.backgroundAlpha = 1;
            }
        }, uiStage, 650, 0);

        this.getButton('判断组件是否在容器中', () => {
            console.log(labelContainer.contains(label)) // 一级
            console.log(containerBottom.contains(label)) // 二级
            console.log(containerRight.contains(label)) // 不存在
        }, uiStage, 650, 0);







    }












    private posY = 15;
    private getButton(title: string, clickFun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 30;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, clickFun);
        target.addChild(button);
        this.posY = this.posY + 30 + y;
        this._buttonList.push(button);
        return button;
    }

    private onRelease() {
        const list = [this._container1, this._container2, this._container3, this._container4
            , this._container5, this._container6, this._containerTop, this._containerLeft, this._containerRight,
        this._containerRight, this._containerBottom];

        for (let i = 0; i < list.length; i++) {
            let item = list[i];
            if (item) {
                item.removeAllListeners();
                item.parent && item.parent.removeChild(item);
                item.release();
                item = undefined;
            }
        }
        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }
}



